
import { defineComponent } from 'vue';

import ChoosePasswordView from '@/learn-login/components/ChoosePasswordView.vue';

export default defineComponent({
  name: 'register',
  components: { ChoosePasswordView },
});
